export const NBSP = '\u00A0';
export const RUBLE_SYMBOL = '\u20BD';
